export default "__VITE_ASSET__BZye2ITs__"